import { RESET_FILTERDATA, SET_FILTERDATA } from '../../constants';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FILTERDATA:
      return action.payload;
    case RESET_FILTERDATA:
      return {};
    default:
      return state;
  }
};
